import { Injectable } from '@angular/core';
import { gridconfig, masterGridConfig } from 'src/app/app-enum.enum';
import { FieldType, Formatters, AngularUtilService, Editors, OnEventArgs } from 'angular-slickgrid';
import { DateTimePickerComponent } from 'src/app/common/components/date-time-picker/date-time-picker.component';
import { CustomAngularComponentEditor } from 'src/app/common/components/cue-table/custom-editors/custom-angular-component-editor';
import { GridDateFormatter } from 'src/app/common/components/cue-table/custom-formatters/custom-date-formatter';
import { AutoCompleteComponent } from 'src/app/common/components/auto-complete/auto-complete.component';
import { CustomAngularComponentFilter } from 'src/app/common/components/cue-table/custom-editors/custom-angular-component-filter';

@Injectable({
  providedIn: 'root'
})
export class ShuttleModalService {
  
  modalFormConfig = {
    'showSideBar': false,
    'showReset': false
  };
  
  constructor(private angularUtilService: AngularUtilService) { }

  //Modal Grid for Route in shuttle summary
  getRouteTableColumnConfigs() {
    return [
      {
      id: 'DEL_TRIP',
      name: '',
      field: '',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<i id="del_leg-'+ dataContext.TRIP_NO +'" class="fa fa-window-close cursor-pointer" title="Delete Route Leg"></i>';
      },
      minWidth: 30
    },
    {
      id: 'ROUTE_DTL_SEQ_NO',
      name: 'Seq No',
      field: 'ROUTE_DTL_SEQ_NO',
      sortable: true,
      type: FieldType.integer,
      editor: { model: Editors.integer },
      minWidth: 25
    },
    {
      id: 'ROUTE_CODE',
      name: 'Arrival Location',
      field: 'ROUTE_CODE',
      comboId: 'strOrigin',
      sortable: true,
      filterable: true,
      queryFieldFilter: 'ROUTE_CODE.id',
      queryFieldSorter: 'ROUTE_CODE.value',
      formatter: Formatters.complexObject,
      params: {
        complexFieldLabel: 'ROUTE_CODE.value',
      },
      editor: {
        model: CustomAngularComponentEditor,
        collection: [],
        params: {
          component: AutoCompleteComponent,
          configs: {
            'id': 'ROUTE_CODE',
            'placeholder': 'Select Location',
            'comboId': 'strOrigin',
            'displayField': 'value',
            'valueField': 'id',
            'enableVirtualScroll': true,
            'bufferSize': 25,
            'isGrid': true,
            'model': '',
            'datasource': []
          }
        }
      },
      filter: {
        model: new CustomAngularComponentFilter(),
        collection: [],
        params: {
          component: AutoCompleteComponent
        }
      },
      minwidth: 280,
    },
      {
        id: 'PICK_TIME',
        name: 'Planned Arrival Time (HH:MM)',
        field: 'PICK_TIME',
        sortable: true,
        minWidth: 100,
        cssClass: 'text-align-right'
      },
      {
        id: 'VACANCY',
        name: 'Vacancy',
        field: 'VACANCY',
        sortable: true,
        minWidth: 60,
        cssClass: 'text-align-right'
      },
      {
        id: 'DISTANCE',
        name: 'Distance (km)',
        field: 'DISTANCE',
        sortable: true,
        type: FieldType.string,
        editor: { model: Editors.text },
        cssClass: 'text-align-right',
        minWidth: 60,
      },
      {
        id: 'TRANSIT_TIME',
        name: 'Transit Time (HH:MM)',
        field: 'TRANSIT_TIME',
        sortable: true,
        type: FieldType.string,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'TRANSIT_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        minWidth: 80,
        cssClass: 'text-align-right'
      },

      {
        id: 'WAITING_TIME',
        name: 'Waiting Time',
        field: 'WAITING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'WAITING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        cssClass: 'text-align-right',
        minWidth: 80
      },
      {
        id: 'BOARDING_TIME',
        name: 'Boarding Time',
        field: 'BOARDING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'BOARDING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        cssClass: 'text-align-right',
        minWidth: 90
      }];
  }

  //Modal Grid for Trip-Pax
  getTripPaxTableColumnConfigs() {
    return [
      {
        id: 'id',
        name: 'Seq No',
        field: 'id',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        formatter: function (row) { return (row + 1); },
        minWidth: 40
      },
      {
        id: 'PASSENGER_NAME',
        name: 'Passenger ID - Name',
        field: 'PASSENGER_NAME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'PASSENGER_CONTACT',
        name: 'Passenger contact',
        field: 'PASSENGER_CONTACT',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'REQUEST_NO',
        name: 'Request No.',
        field: 'REQUEST_NO',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'REQ_PICK_DT_TM',
        name: 'Req Pick datetime',
        field: 'REQ_PICK_DT_TM',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'REQ_DROP_DT_TM',
        name: 'Req Drop datetime',
        field: 'REQ_DROP_DT_TM',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'PICK_LOCATION',
        name: 'Pick Location',
        field: 'PICK_LOCATION',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'DROP_LOCATION',
        name: 'Drop location',
        field: 'DROP_LOCATION',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },

      {
        id: 'PLANNED_PICK_TIME',
        name: 'Planned pick datetime',
        field: 'PLANNED_PICK_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'PLANNED_DROP_TIME',
        name: 'Planned drop datetime',
        field: 'PLANNED_DROP_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'ACTUAL_PICK_TIME',
        name: 'Actual Pick up datetime',
        field: 'ACTUAL_PICK_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'ACTUAL_DROP_TIME',
        name: 'Actual Drop datetime',
        field: 'ACTUAL_DROP_TIME',
        sortable: true,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'PASSENGER_STATUS',
        name: 'Passenger Status',
        field: 'PASSENGER_STATUS',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'IN_TIME',
        name: 'In Time',
        field: 'inTime',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'OUT_TIME',
        name: 'Out Time',
        field: 'outTime',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'NO_SHOW_TIME',
        name: 'No Show Time',
        field: 'noShowTime',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 120
      },
      {
        id: 'ADHOC/PLANNED',
        name: 'Adhoc/Planned',
        field: 'Adhoc/Planned',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 100
      },
      {
        id: 'QR_SCAN_IN',
        name: 'QR Scan IN',
        field: 'QR_SCAN_IN',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 60
      },
      {
        id: 'QR_SCAN_OUT',
        name: 'QR Scan OUT',
        field: 'QR_SCAN_OUT',
        sortable: true,
        type: FieldType.string,
        columnGroup: 'Trip Passenger Details',
        minWidth: 60
      }];
  }

  //Summary config
  getShuttleSummaryTableConfigs() {
    return {
      gridId: 'paxShuttleTableInRoute',
      idField: 'id',
      recStatus: 'I',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Shuttle Route List',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: true,
      canDeleteRowManually: true,
      canCopyRows: false,
      showColumnFilter: false,
      showFilter: true,
      emptyObject: {},
      enableAutoResize: true, // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      editable: true,
      rowSelectionOptions: {  
        selectActiveRow: true // True (Single Selection), False (Multiple Selections)
      },
      autoResize: {
        maxHeight: masterGridConfig.gridHeightForMasterList,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: false,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      autoCommitEdit: true,
      alwaysShowVerticalScroll: true,
      enableAsyncPostRender: true,
      asyncPostRenderDelay: 0,
      asyncEditorLoading: false,
      selectedRowKeyName: 'id',
      params: { angularUtilService: this.angularUtilService },
      forceFitColumns: false
    };
  }

  //trip config
  getTripModalTableConfigs() {
    return {
      gridId: 'tripPaxModalTable',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true,
      selectionMode: 'multiple',
      exportFileName: 'Report List',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      showFilter: true,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      autoResize: {
        maxHeight: masterGridConfig.gridHeightForMasterList,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: false,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      alwaysShowVerticalScroll: true,
      forceFitColumns: false,
      enableSorting: true,
      asyncEditorLoading: false,
      autoCommitEdit: true,
      enableAsyncPostRender: true,
      asyncPostRenderDelay: 0,
      selectedRowKeyName: 'id',
      params: { angularUtilService: this.angularUtilService }
    };
  }
  //Shuttle MApping pivot FormTemplate
  getPivotPointTemplate(scope) {
    return [{
      'id': 'startTime',
      'labelName': 'Start Time (HH:MM)',
      'type': 'picker',
      'placeholder': 'HH:MM',
      'isVisible': true,
      'pickerType': 'timer',
      'dateFormat': 'HH:MM',
      'isReadOnly': false,
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 1,
      'class': 'col-md-3',
      'onSelect': scope.onSelectDate,
      'scope': scope
    }, {
      'id': 'dropTime',
      'labelName': 'End Time (HH:MM)',
      'type': 'picker',
      'placeholder': 'HH:MM',
      'isVisible': true,
      'pickerType': 'timer',
      'dateFormat': 'HH:MM',
      'isReadOnly': false,
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 1,
      'class': 'col-md-3',
      'onSelect': scope.onSelectDate,
      'scope': scope
    }, {
      'id': 'strOrigin',
      'labelName': 'Pivot Point',
      'type': 'search',
      'minlength': 1,
      'placeholder': '',
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': '',
      'datasource': [],
      'validations': [],
      'position': 0,
      'class': 'col-md-3',
      'onSuggestionSelected': scope.onSelectPivotPoint,
      'scope': scope
    }, {
      'id': 'strPivotTime',
      'labelName': 'Pivot Time',
      'type': 'picker',
      'placeholder': 'HH:MM',
      'isVisible': true,
      'pickerType': 'timer',
      'isReadOnly': false,
      'maxDate': '',
      'minDate': '',
      'invalidDates': [],
      'disabledDays': [],
      'noOfMonths': 1,
      'validations': [],
      'position': 2,
      'class': 'col-md-3',
      'onSelect': scope.onSelectDate,
      'scope': scope
    }];
  }

  //Modal Grid for Route in shuttle mapping
  getRouteTableColumnConfigsInMapping() {
    return [
      {
        id: 'ROUTE_DTL_SEQ_NO',
        name: 'Seq No',
        field: 'ROUTE_DTL_SEQ_NO',
        sortable: true,
        type: FieldType.integer,
        editor: { model: Editors.integer },
        formatter: function (row) { return (row + 1); },
        minWidth: 25
      },
      {
        id: 'ROUTE_CODE',
        name: 'Arrival Location',
        field: 'ROUTE_CODE',
        sortable: true,
        minWidth: 180
      },
      {
        id: 'PICK_TIME',
        name: 'Planned Arrival Time (HH:MM)',
        field: 'PICK_TIME',
        sortable: true,
        minWidth: 100,
        cssClass: 'text-align-right'
      },
      {
        id: 'DISTANCE',
        name: 'Distance (km)',
        field: 'DISTANCE',
        sortable: true,
        type: FieldType.string,
        cssClass: 'text-align-right',
        minWidth: 60,
      },
      {
        id: 'TRANSIT_TIME',
        name: 'Transit Time (HH:MM)',
        field: 'TRANSIT_TIME',
        sortable: true,
        type: FieldType.string,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'TRANSIT_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        minWidth: 70,
        cssClass: 'text-align-right'
      },

      {
        id: 'WAITING_TIME',
        name: 'Waiting Time',
        field: 'WAITING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'WAITING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        cssClass: 'text-align-right',
        minWidth: 70
      },
      {
        id: 'BOARDING_TIME',
        name: 'Boarding Time',
        field: 'BOARDING_TIME',
        sortable: true,
        dateFormat: 'HH:mm',
        formatter: GridDateFormatter,
        type: FieldType.string,
        editor: {
          model: CustomAngularComponentEditor,
          params: {
            component: DateTimePickerComponent,
            configs: {
              'id': 'BOARDING_TIME',
              'type': 'datePicker',
              'maxDate': '',
              'minDate': '',
              'invalidDates': [],
              'disabledDays': [],
              'validations': [],
              'noOfMonths': 1,
              'isDisabled': false,
              'isGrid': true,
              'model': '',
              'dateFormat': 'HH:mm',
              'placeholder': 'HH:MM',
              'pickerType': 'timer'
            }
          }
        },
        cssClass: 'text-align-right',
        minWidth: 70
      }, {
        id: 'PIVOT_POINT',
        name: 'Pivot Point',
        field: 'PIVOT_POINT',
        sortable: true,
        minWidth: 100,
      }];
  }

  //Mapping config
  getShuttleMappingTableConfigs() {
    return {
      gridId: 'routeTableMapping',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true,
      selectionMode: 'multiple',
      exportFileName: 'Route Details',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      showFilter: true,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: true,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      autoResize: {
        maxHeight: masterGridConfig.gridHeightForMasterList,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: false,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      asyncEditorLoading: false,
      autoCommitEdit: true,
      enableAsyncPostRender: true,
      asyncPostRenderDelay: 0,
      params: { angularUtilService: this.angularUtilService }
    };
  }
}
